import { css } from 'styled-components';

const style = () => css`
    background-color: #fff;
    border-radius: 5px;
    min-height: 300px;
`;

export default style();
